import React from 'react';
import PropTypes from 'prop-types';
import { Card, Title } from '@paygreen/paygreen-ui';

const CardClassic = ({
    t,
    title,
    titleColorWab,
    titleAlign,
    titleSize,
    paddingTop,
    paddingBottom,
    paddingLateral,
    blockWidth,
    radiusSize,
    children,
    ...rest
}) => {
    return (
        <Card
            blockWidth={blockWidth}
            paddingLateral={paddingLateral}
            paddingTop={paddingTop}
            paddingBottom={paddingBottom}
            radiusSize={radiusSize}
            {...rest}
        >
            {title ? (
                <Title
                    htmlTag="h2"
                    marginBottom="sm"
                    colorWab={titleColorWab}
                    align={titleAlign}
                    textSize={titleSize}
                >
                    {title}
                </Title>
            ) : null}

            {children}
        </Card>
    );
};

CardClassic.propTypes = {
    title: PropTypes.string,
    paddingTop: PropTypes.string,
    paddingBottom: PropTypes.string,
    paddingLateral: PropTypes.string,
    blockWidth: PropTypes.string,
    titleColorWab: PropTypes.string,
    titleAlign: PropTypes.string,
    titleSize: PropTypes.string,
    radiusSize: PropTypes.string,
};

CardClassic.defaultProps = {
    paddingTop: 'sm',
    paddingLateral: 'sm',
    paddingBottom: 'sm',
    blockWidth: 'md',
    titleColorWab: 'grey50',
    titleAlign: 'left',
    titleSize: 'base',
    radiusSize: 'sm',
};

export default CardClassic;
